import omit from 'lodash/omit';

import {
  Project,
  ProjectsState,
  PublishHistory,
} from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

export type OldPublishHistory = Omit<PublishHistory, 'databaseInfo'> & {
  connectionInfo: {
    databaseId: string;
  };
  databaseInfo: {
    shouldEnableVoicebox?: boolean;
    isPublishingSPG: boolean;
  };
};

/**
 * Migration to remove connectionInfo from PublishHistory, and move databaseId from PublishHistory.connectionInfo
 * to PublishHistory.databaseInfo
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v42 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v42Projects(prevState.projects);
  }

  return nextState;
};

const v42Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    const oldPublishHistory = {
      ...project.publishHistory,
    } as any as OldPublishHistory;
    const oldPublishHistoryWithoutConnectionInfo = omit(
      oldPublishHistory,
      'connectionInfo'
    );

    const publishHistory: PublishHistory = {
      ...oldPublishHistoryWithoutConnectionInfo,
      databaseInfo: {
        ...oldPublishHistoryWithoutConnectionInfo.databaseInfo,
        databaseId: oldPublishHistory.connectionInfo.databaseId,
      },
    };
    projectsById[projectId] = {
      ...project,
      publishHistory,
    };
  });

  return { ...prevProjectsState, projectsById };
};
